import(/* webpackMode: "eager", webpackExports: ["MVFooter"] */ "C:\\manish-works\\touches\\lokbharti\\Lokbharati\\app\\mv-tutorials\\components\\footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MVHeader"] */ "C:\\manish-works\\touches\\lokbharti\\Lokbharati\\app\\mv-tutorials\\components\\header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GeneralInfoTemplate"] */ "C:\\manish-works\\touches\\lokbharti\\Lokbharati\\components\\general-info-template.tsx");
